module.exports = __webpack_public_path__ + "static/media/gain_xp.edf9d6e9.png";